import { lazy } from 'react';

// // project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// // login option 3 routing
const PreviewContent = Loadable(lazy(() => import('views/contents/pages/PreviewContent.page')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const PreviewRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/contents/preview/:template/:id',
      element: <PreviewContent />
    }
  ]
};

export default PreviewRoutes;
